export default function isAllUsers(state) {
    return state.toggleAllUsers === true;
}